// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__190Ra","footer":"ModalInfo_footer__y76xq"};